module.exports = __webpack_public_path__ + "static/media/jumping_peda1.bafbbd37.gif";